import axios from "axios";
import { RAPSAP_OPS_BASE_URL } from "../config";
import { getAdminToken } from "./session";

// The staff API (RAPSAP_OPS_BASE_URL) takes the same login token as the main
// API, so every call acts as the logged-in user. It used to log in on its own
// with a shared account; drop anything that login left behind.
[
  "rapid_token",
  "rapid_token_expiry",
  "rapid_user_info",
  "rapsap_ops_token",
  "rapsap_ops_token_expiry",
  "rapsap_ops_user_info",
].forEach((key) => localStorage.removeItem(key));

// The logged-in user's token. Async to keep the old call sites unchanged.
export const getOpsToken = async () => getAdminToken();

// Nothing of its own to clear any more; logging out clears the shared token.
export const clearOpsAuth = () => {};

// The logged-in user, as returned by the login.
export const getOpsUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("user_data"));
  } catch (e) {
    return null;
  }
};

export const isTokenValid = () => Boolean(getAdminToken());

// Main API call function. Returns the response body, or null when there's
// no login or the request fails, so callers can handle empty responses.
export const opsApiCall = async (endpoint, payload = {}, method = "POST") => {
  const token = getAdminToken();
  if (!token) return null;

  const url = `${RAPSAP_OPS_BASE_URL}${endpoint.replace(/^\//, "")}`;
  const config = {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  };

  try {
    const resp =
      method.toUpperCase() === "GET"
        ? await axios.get(url, { params: payload, ...config })
        : await axios.post(url, payload, config);
    return resp.data || null;
  } catch (error) {
    // A rejected token (401) still comes back as a body the caller can read.
    if (error?.response?.status === 401) return error.response.data || null;
    console.error("opsApiCall error for", endpoint, error?.response || error.message);
    return null;
  }
};
